import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import Select from "../../components/form/Select";
import SelectAjax from "../../components/form/SelectAjax";
import BtBloco from '../../components/buttons/BtBloco';
import DateRangePickerWrapper from "../../components/form/DateRangePickerWrapper";
import Ws from '../../config/Ws';
import TipoPlanilha from "./TipoPlanilha";
import TIPOS_PLANILHA from "../../data/TiposPlanilha";
import Random from "../../utils/strings/Random";
import ButtonTipoTreino from './ButtonTipoTreino';
import SEXOS from "../../data/Sexos";
import Planilha from "./Planilha";


class Component extends React.Component{
  constructor(props){
    super(props);

    this.changeSexo = this.changeSexo.bind(this);
    this.state = {
      sexoAtivo:SEXOS[0].value,
      sexos:SEXOS,
      dados:props.data
    };
  }

  changeSexo(e){
    let id = e.currentTarget.getAttribute("data-id");
    this.setState({sexoAtivo: id});
    e.preventDefault();
  }

  render(){
    const sexos = this.state.sexos;
    const sexoAtivo = this.state.sexoAtivo;

    const listSexos = sexos.map((tipoTreino,i)=>{
        let ativo = tipoTreino.value === sexoAtivo;
        const data = this.state.dados[tipoTreino.identifier] ? this.state.dados[tipoTreino.identifier] : [];

        return (
          <Planilha
            sexoAtivo={sexoAtivo}
            data={data}
            identifier={tipoTreino.identifier}
            id={Random(7)}
            key={i.toString()}
            ativo={ativo}>
          </Planilha>
        )
      }
    );//end map

    const buttonsSexos = sexos.map((tipoTreino,i)=>{
      let ativo = tipoTreino.value === sexoAtivo;
        return (
          <ButtonTipoTreino
            key={i.toString()}
            id={tipoTreino.value}
            onClick={this.changeSexo}
            label={tipoTreino.label}
            ativo={ativo}>
          </ButtonTipoTreino>
        )
      }
    );//end map
    return (
      <div>
        <div className="pure-u-9-24 box-tipos-planilha">
          <div className="box-input--title">Sexo</div>
          {buttonsSexos}
        </div>
        {listSexos}
      </div>
    )
  }
}

export default Component;



// WEBPACK FOOTER //
// ./src/classes/treino-home/Component.js